// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "0bdcc44f99d6af5911ab" + ".bundle.js";
};